import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "kt_sidebar_content",
  class: "py-10 px-2 px-lg-8"
}
const _hoisted_2 = {
  class: "hover-scroll-y me-lg-n5 pe-lg-4",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "10px",
  "data-kt-scroll-wrappers": "#kt_sidebar_content"
}
const _hoisted_3 = { class: "card card-custom bg-info" }
const _hoisted_4 = { class: "card-body px-0" }
const _hoisted_5 = { class: "pt-0" }
const _hoisted_6 = {
  class: "d-flex flex-center position-relative bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-center",
  style: {"background-image":"url('media/svg/illustrations/bg-2.svg')"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute mb-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-100px overflow-hidden d-flex flex-center z-index-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-warning align-items-end" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "Logo",
        src: "media/svg/avatars/016-boy-7.svg",
        class: "mh-75px"
      })
    ])
  ])
], -1)
const _hoisted_8 = {
  id: "kt_user_chart",
  style: {"height":"200px","min-height":"178.7px"}
}
const _hoisted_9 = { class: "pt-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-center pb-12" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-white fs-2 pb-4" }, "Mr. Anderson"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-primary px-4 py-2 rounded bg-white bg-opacity-10" }, "Python Dev")
], -1)
const _hoisted_11 = { class: "row row-cols-2 px-xl-12 sidebar-toolbar" }
const _hoisted_12 = { class: "col p-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bolder fs-1 d-block pb-1" }, "38", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Pending", -1)
const _hoisted_15 = { class: "col p-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bolder fs-1 d-block pb-1" }, "204", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Completed", -1)
const _hoisted_18 = { class: "col p-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bolder fs-1 d-block pb-1" }, "76", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "On Hold", -1)
const _hoisted_21 = { class: "col p-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bolder fs-1 d-block pb-1" }, "9", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "In Progress", -1)
const _hoisted_24 = { class: "card card-custom bg-info" }
const _hoisted_25 = { class: "card-header align-items-center border-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white fs-3" }, "Fox Bestsellers", -1)
const _hoisted_27 = { class: "card-toolbar" }
const _hoisted_28 = {
  type: "button",
  class: "btn btn-md btn-icon btn-icon-white btn-info",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_29 = { class: "svg-icon svg-icon-2" }
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "symbol symbol-40px symbol-2by3 me-4" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3" }
const _hoisted_34 = {
  href: "#",
  class: "text-white fw-bolder text-hover-primary fs-6"
}
const _hoisted_35 = { class: "text-white opacity-25 fw-bold fs-7 my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_apexchart, {
                  options: _ctx.chartOptions,
                  series: _ctx.series,
                  height: "200",
                  type: "radialBar"
                }, null, 8, ["options", "series"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "btn p-5 w-100 text-start btn-active-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "btn p-5 w-100 text-start btn-active-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "btn p-5 w-100 text-start btn-active-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "btn p-5 w-100 text-start btn-active-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
              ])
            ]),
            _createVNode(_component_Dropdown3)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "d-flex flex-wrap align-items-center mb-7"
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("img", {
                  src: item.image,
                  alt: "",
                  class: "mw-100"
                }, null, 8, _hoisted_32)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("a", _hoisted_34, _toDisplayString(item.title), 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(item.desc), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}